module.exports = __webpack_public_path__ + "static/img/xkxslb_main_header.f2cd532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xkxslb_main_header.png
// module id = SL0m
// module chunks = 167